/**
 * Wires up a mute/unmute button (data-media-mute-toggle) against the
 * <video> (data-media-video) in the same wrapper (data-media-wrapper) —
 * shared by the Hero background video and the Video block's reveal-on-play
 * video, both of which use the same button markup/styling.
 */
class MediaMuteToggle {
  constructor(button) {
    this.NAME = 'MediaMuteToggle';
    this.button = button;
    const wrapper = button.closest('[data-media-wrapper]');
    this.video = wrapper ? wrapper.querySelector('[data-media-video]') : null;
  }

  init() {
    if (!this.video) return;
    this.syncState();
    this.button.addEventListener('click', () => this.toggle());
  }

  toggle() {
    this.video.muted = !this.video.muted;
    this.syncState();
  }

  // Keeps the button's class/aria in sync with the video's actual muted
  // state — called on init too, since Hero's video starts muted and
  // Video block's starts unmuted, and the button markup should reflect
  // whichever is actually true rather than assuming one or the other.
  syncState() {
    this.button.classList.toggle('is-unmuted', !this.video.muted);
    this.button.setAttribute('aria-pressed', String(this.video.muted));
    this.button.setAttribute('aria-label', this.video.muted ? 'Unmute video' : 'Mute video');
  }
}

export default MediaMuteToggle;
